var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownGrayIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 11,
    viewBox: "0 0 20 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.990194 0.380479C0.500195 0.870479 0.500195 1.66048 0.990194 2.15048L9.3002 10.4605C9.6902 10.8505 10.3202 10.8505 10.7102 10.4605L19.0202 2.15048C19.5102 1.66048 19.5102 0.870479 19.0202 0.380479C18.5302 -0.109521 17.7402 -0.109521 17.2502 0.380479L10.0002 7.62048L2.75019 0.370478C2.2702 -0.109522 1.47019 -0.109521 0.990194 0.380479Z",
    fill: "#444955"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownGrayIcon);
export default __webpack_public_path__ + "static/media/dropdown-gray-icon.fc7d746ddd2c2af3698276a6fb9e82e4.svg";
export { ForwardRef as ReactComponent };